import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentsSharedModule } from '@app/payments/payments-shared/payments-shared.module';
import { SharedModule } from '@app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

import { AchFormRetrievalPageRoutingModule } from './ach-form-retrieval-routing.module';
import { AchFormRetrievalPage } from './ach-form-retrieval.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    SharedModule,
    PaymentsSharedModule,
    ReactiveFormsModule,
    AchFormRetrievalPageRoutingModule,
  ],
  declarations: [AchFormRetrievalPage],
})
export class AchFormRetrievalPageModule {}
